var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarBeta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.12C0 21.6068 0.39325 22 0.88 22H21.12C21.6068 22 22 21.6068 22 21.12V9.57H0V21.12ZM21.12 1.98H16.5V0.22C16.5 0.099 16.401 0 16.28 0H14.74C14.619 0 14.52 0.099 14.52 0.22V1.98H7.48V0.22C7.48 0.099 7.381 0 7.26 0H5.72C5.599 0 5.5 0.099 5.5 0.22V1.98H0.88C0.39325 1.98 0 2.37325 0 2.86V7.7H22V2.86C22 2.37325 21.6068 1.98 21.12 1.98Z",
    fill: "#4C555C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBeta);
export default __webpack_public_path__ + "static/media/calendarBeta.296a89d0.svg";
export { ForwardRef as ReactComponent };